import { render, staticRenderFns } from "./DonutOverview.vue?vue&type=template&id=5528f00c&scoped=true&lang=pug&"
import script from "./DonutOverview.vue?vue&type=script&lang=ts&"
export * from "./DonutOverview.vue?vue&type=script&lang=ts&"
import style0 from "./DonutOverview.vue?vue&type=style&index=0&id=5528f00c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5528f00c",
  null
  
)

export default component.exports